import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';
import { TenantDto, UserTenantDto } from 'projects/shared/src/lib/models/TenantDto';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';

@Component({
  selector: 'add-project-dialog',
  templateUrl: './add-project-dialog.component.html',
  styleUrls: ['./add-project-dialog.component.scss']
})
export class AddProjectDialogComponent implements OnInit {

  projectCreationForm!: FormGroup;
  public color: ThemePalette = 'primary';
  public listColors = ['primary', 'accent', 'warn'];
  public lat:number = 0.0;
  public lon:number = 0.0;

  //tenants:TenantDto[] = [];
  _isadmin!:string;
  servers:string[] = [];
  serverName!:string;
  isLoading = true;
  serverSelected = false;


  constructor(private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<AddProjectDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              public translate: TranslateService,
              private tenantService: TenantService,
              private oauthService: OAuthServiceService) { }

  ngOnInit() {
      // this.tenantService.getUserTenant().subscribe({
      //   next: (data:UserTenantDto) => {
      //     const tenant = new TenantDto;
      //     tenant.displayName = data.tenantName;
      //     tenant.name = data.tenantName;
      //     tenant.id = data.tenantId;
  
      //     this.tenants.push(tenant)  
      //   }
      // })
      this.tenantService.getServers(this.tenantService.currentTenantName).subscribe({
        next:(servers) => {
            this.isLoading = false;
            this.servers = servers;
            console.log("============> servers: ", this.servers)
            this.createProjectForm();
          },
         //error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["PROJECTCLONEDERROR"]}`)
      })   
  
   }

   get admin(): string {
    this.oauthService.userData.subscribe({
      next: (data) => {
        if (typeof data != undefined && data != null) {
          let userRoles = data.role as Array<string>;
          userRoles.forEach((dbrole: string) => {
            if (dbrole === 'admin' ) {
              this._isadmin = dbrole;
            }
          });
        }
      }
    });
    return this._isadmin;
  }

  createProjectForm(){
    this.projectCreationForm = this.formBuilder.group({
//      tenant:[null],
      name:[null, Validators.required],
//      url:[null, Validators.required],
      // latitude:[this.lat],
      // longitude:[this.lon],
      description:[null],
      serverName:[null, Validators.required]
//      color:[null]
    });
  }

  add() {
    if(this.projectCreationForm.valid){
      this.dialogRef.close(this.projectCreationForm.value);
    }
  }

  cancel() {
    this.dialogRef.close();
  }

  optionSelected(event: any) {
    // console.log("------------> name = ",this.projectCreationForm.value.name)
    // console.log("------------> desc = ",this.projectCreationForm.value.description)
    // console.log("------------> server = ",this.projectCreationForm.value.serverName)
    this.serverName = event.option.value;
    this.projectCreationForm.setValue({
      // name: this.projectCreationForm.value.name,
      // description: this.projectCreationForm.value.description,
      serverName: this.serverName
    });
    this.serverSelected = true;
    // console.log("------------> form = ",this.projectCreationForm)
  }

}
